<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>

<div class="container-fluid pt-5">
  <div class="d-flex justify-content-end"> 
    <div class="col-xl-9 col-lg-9 col-md-8 p-2">
    
      <div class="row">            
        <!-- Top Slideshow -->
        <div class="col-12"> 
          <div class="card my-3">
            <div id="carouselExampleControls2" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <ng-container *ngFor="let doc of pictureCol | async; index as i; first as isFirst; last as isLast">        
                  <div [ngClass]="isFirst ? 'carousel-item active' : 'carousel-item' ">
                    <div class="">
                      <img [src]="doc.pictureUrl" class="card-img-top" style="height: 12rem;" alt="...">
                      
                    </div>
                  </div>  
                </ng-container>       
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>   
        </div>

        <!-- left column - Package Brief -->        
        <div class="col-xl-6 col-lg-6 col-md-12">
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Tour Package Brief</h2>
              <ul class="list-group list-group-flush">
                <li class="list-group-item font-weight-bold">{{(storeproductDoc | async)?.name}}</li>
                <li class="list-group-item">{{(storeproductDoc | async)?.location}}</li>
                <li class="list-group-item">{{(storeproductDoc | async)?.duration}} days</li>
                <li class="list-group-item">{{(storeproductDoc | async)?.price | currency: 'K'}}</li>
              </ul>                  
            </div> 
          </div> 
          <div class="card mx-auto my-3 shadow-lg card-sticky">                                           
            <div class="card-body">
              <h2>Tour Operator Details</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item font-weight-bold">{{(storeproductDoc | async)?.ownerName}}</li>
                <li class="list-group-item">{{(storeproductDoc | async)?.ownerPhone}}</li>
                <li class="list-group-item">{{(storeproductDoc | async)?.ownerEmail}}</li>
                <li class="list-group-item">{{(storeproductDoc | async)?.ownerWebsiteUrl}}</li>
              </ul>                  
            </div> 
          </div>                              
        </div>
        
        <!-- right column - Package Details -->
        <div class="col-xl-6 col-lg-6 col-md-12">
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Tour Overview</h2> 
              <p class="card-text">
                {{(storeproductDoc | async)?.overview}}
              </p>                  
            </div>
          </div>                    
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Inclusions</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (storeproductDoc | async)?.inclusions">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>
                    {{array}}                                           
                </li>
              </ul>                
            </div>
          </div>
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Exclusions</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (storeproductDoc | async)?.exclusions">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>                  
                    {{array}}                                        
                </li>
              </ul>                
            </div>
          </div>
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Cancellation Policy</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (storeproductDoc | async)?.cancellations">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>                  
                    {{array}}                                          
                </li>
              </ul>                
            </div>
          </div>    
          <div class="card mx-auto my-3 shadow-lg">                                           
            <div class="card-body">
              <h2>Refund Policy</h2> 
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let array of (storeproductDoc | async)?.refunds">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-check2-circle text-success" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
                    </svg>                  
                    {{array}}                                          
                </li>
              </ul>                
            </div>
          </div>          
        </div>        
      </div>

      <!-- Itinerary -->
      <div class="row bg-white m-1">   
          <h2 class="m-3 btn btn-block">Itinerary</h2>     
          <div class="col-xl-6 col-lg-6 col-md-12" *ngFor="let doc of itineraryCol | async">
              <div class="card mx-auto my-3 shadow-lg">                                                                   
                  <div class="card-body">
                      <h2>{{ doc.name }}</h2> 
                      <ul class="list-group list-group-flush">
                          <li class="list-group-item">{{ doc.activity }}</li>
                        </ul>                  
                  </div>
              </div>
          </div>
      </div>
      
    </div>
  </div>
</div>
